import React from 'react';

import { ButtonProps } from 'primereact/button';

import { PrimeButtonCustomProps, StyledButton } from './styled';

export const PrimeButton = (props: ButtonProps & PrimeButtonCustomProps) => {
  return <StyledButton {...props} />;
};
